import { Component, OnInit } from "@angular/core";
import { TabIdList } from "../shared/models/tab.model";
import { RouteEnum } from "../shared/models/routes.model";
import { UiUser } from "../shared/models/ui-user.model";
import { AuthService } from "../shared/services/auth.service";
import { Store } from "@ngrx/store";
import { selectedUser, ui_tabIdList } from "../shared/ngrx/ngrx-selectors";
import { Subject } from "rxjs";
import { ofType, Actions } from "@ngrx/effects";
import { map, take, takeUntil } from "rxjs/operators";
import { EDIT_USER } from "../shared/ngrx/ngrx-actions";
import { TabSingleComponent } from "../shared/components/ui/tabs/tab-single/tab-single.component";
import { TabsComponent } from "../shared/components/ui/tabs/tabs.component";
import { ModalPopupComponent } from "../shared/components/ui/modal-popup.component";
import { CommonModule } from "@angular/common";
import { UserEditComponent } from "./user-edit/user-edit.component";

@Component({
  selector: "app-mng",
  templateUrl: "./mng.component.html",
  styleUrls: ["./mng.component.sass"],
  imports: [
    TabSingleComponent,
    TabsComponent,
    ModalPopupComponent,
    CommonModule,
    UserEditComponent,
  ],
  standalone: true,
})
export class MngComponent implements OnInit {
  routeEnum: RouteEnum = new RouteEnum();
  tabIdList: TabIdList;
  urlMngClinics: string = this.routeEnum.URL_MNG_CLINICS;
  urlMngUsers: string = this.routeEnum.URL_MNG_USERS;
  urlMngParams: string = this.routeEnum.URL_MNG_PARAMS;
  urlMngDrProfile: string = this.routeEnum.URL_MNG_DR_PROFILE;
  createUserPanelDisplay: boolean;
  destroy$ = new Subject();
  allowDrProfiles: boolean;

  get selectedUser(): UiUser {
    return this.store.selectSignal(selectedUser)();
  }

  constructor(
    private readonly store: Store,
    private authService: AuthService,
    private actions$: Actions
  ) {
    this.actions$
      .pipe(
        ofType(EDIT_USER),
        takeUntil(this.destroy$),
        map(({}) => {
          this.createUserPanelDisplay = true;
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next(1);
  }

  ngOnInit(): void {
    this.allowDrProfiles =
      this.authService.currentUser.authDetails.getBooleanValue(
        "MNG.DR_PROFILE.ALLOWED_SW"
      );
    this.tabIdList = this.store.selectSignal(ui_tabIdList)();
  }
}
